import { createDrawerNavigator } from "@react-navigation/drawer";
import { useMediaQuery } from "native-base";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorToast from "../components/ErrorToast";
import LoadingIndicator from "../components/LoadingIndicator";
import { getBalance } from "../redux/slices/BalanceSlice";
import { getNavLinks } from "../redux/slices/NavMenuSlice";
import { getSetting } from "../redux/slices/settingSlice";
import MemberPage from "../screens/Member/Member";
import { isWeb } from "../utils/utils";
import LoggedInDrawer from "./components/LoggedInDrawer";
import MemberHeader from "./components/MemberHeader";

const Member = createDrawerNavigator();

const MemberPages = () => {
	const dispatch = useDispatch();

	React.useEffect(() => {
		try {
			dispatch(getNavLinks());
			dispatch(getSetting());
			dispatch(getBalance());
		} catch (error) {
			ErrorToast(error.message);
		}
	}, []);

	const NavLinks = useSelector((state) => state.Nav.NavLinks);
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	return (
		<>
			{NavLinks.length <= 0 ? (
				<LoadingIndicator />
			) : (
				<Member.Navigator
					drawerContent={(props) => <LoggedInDrawer {...props} />}
				>
					{NavLinks?.data.map((item, index) => {
						let meta = item.meta_data;
						if (meta.location == "main") {
							if (
								item.children !== undefined &&
								item.children.length > 0 &&
								isWeb()
							) {
								let hasFirst = false;
								let children = item.children.map((c_item, c_index) => {
									let meta = c_item.meta_data;
									if (meta.cast_as_anchor == true) {
										if (!hasFirst) {
											hasFirst = true;
											return (
												<Member.Screen
													key={index + Math.random()}
													name={item.page_title}
													component={MemberPage}
													initialParams={{ slug: item.slug }}
													options={
														meta.visible === false
															? {
																	drawerLabel: () => null,
																	drawerIcon: () => null,
																	drawerItemStyle: {
																		height: 0,
																		padding: 0,
																		margin: 0,
																	},
																	header: (props) => (
																		<MemberHeader props={props} />
																	),
															  }
															: {
																	header: (props) => (
																		<MemberHeader props={props} />
																	),
															  }
													}
												/>
											);
										}
										if (isDesktopOrLaptop[0]) {
											return (
												<Member.Screen
													key={index + Math.random()}
													name={c_item.page_title}
													component={MemberPage}
													initialParams={{ slug: c_item.slug }}
													options={
														meta.visible === false
															? {
																	drawerLabel: () => null,
																	drawerIcon: () => null,
																	drawerItemStyle: {
																		height: 0,
																		padding: 0,
																		margin: 0,
																	},
																	header: (props) => (
																		<MemberHeader props={props} />
																	),
															  }
															: {
																	header: (props) => (
																		<MemberHeader props={props} />
																	),
															  }
													}
												/>
											);
										}
									}
								});

								return children;
							} else {
								if (meta.icon) {
									const icon = meta.icon;
									return (
										<Member.Screen
											key={index + Math.random()}
											name={item.page_title}
											component={MemberPage}
											initialParams={{ slug: item.slug }}
											options={
												meta.visible === false
													? {
															drawerLabel: () => null,
															drawerIcon: () => null,
															drawerItemStyle: {
																height: 0,
																padding: 0,
																margin: 0,
															},
															header: (props) => <MemberHeader props={props} />,
													  }
													: {
															header: (props) => <MemberHeader props={props} />,
													  }
											}
										/>
									);
								} else {
									return (
										<Member.Screen
											key={index + Math.random()}
											name={item.page_title}
											component={MemberPage}
											initialParams={{ slug: item.slug }}
											options={
												meta.visible === false
													? {
															drawerLabel: () => null,
															drawerIcon: () => null,
															drawerItemStyle: {
																height: 0,
																padding: 0,
																margin: 0,
															},
															header: (props) => <MemberHeader props={props} />,
													  }
													: {
															header: (props) => <MemberHeader props={props} />,
													  }
											}
										/>
									);
								}
							}
						}
					})}
				</Member.Navigator>
			)}
		</>
	);
};

export default MemberPages;
